import React from "react";
import tw from "twin.macro";
import { Container as ContainerBase } from "components/misc/Layouts.js";
import logo from "../../images/logos/logosafetylocks.png";
import { PrimaryButton } from "../misc/Buttons";
import {LogoLink} from "../headers/light";

const Container = tw(ContainerBase)`bg-gray-400 text-black -mx-8 -mb-8`;
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;

const Row = tw.div`flex flex-col lg:flex-row justify-between items-center px-8`;

const Column = tw.div`w-full md:w-1/4 text-center mb-8 lg:mb-0`;
const LogoContainer = tw.div`flex flex-col sm:ml-10 items-center`;

const LinksContainer = tw.div`font-medium flex flex-col justify-center items-center mt-8 lg:mt-0`;
const Link = tw.a`border-b-2 border-transparent hocus:text-gray-300 hocus:border-gray-300 pb-1 transition duration-300 mt-2`;


const FooterSection = tw.div`w-full lg:w-1/4 flex flex-col items-center mb-8 lg:mb-0`;
const FooterHeading = tw.h6`text-xl font-bold`;
const FooterText = tw.p`mt-4 text-sm`;

const CopyrightText = tw.p`text-center mt-10 font-medium tracking-wide text-sm text-gray-600`;

export default () => {
  return (
      <Container>
        <Content>
          <Row>
            <Column tw="text-center flex flex-col items-center">
              <LogoContainer>
                <LogoLink href="/">
                  <img src={logo} alt="logo" className={"w-56 h-10"} />
                </LogoLink>
              </LogoContainer>

              <LinksContainer>
                <Link href="/#diensten">Diensten</Link>
                <Link href="/#aanbiedingen">Aanbiedingen</Link>
                <Link href="/#blogs">Blogs</Link>
                <Link href="/#faq">Vragen</Link>
                <Link href="/zakelijk">Zakelijk</Link>
                <Link href="/#contact">Contact</Link>
              </LinksContainer>
            </Column>
            <FooterSection>
              <FooterHeading>Contact Informatie</FooterHeading>
              <FooterText tw={"text-center"}>
                Keyservice <br />
                Telefoon: nvt <br />
                KVK-nummer: nvt <br />
                Email: info@safetylocks.nl
              </FooterText>
            </FooterSection>
            <FooterSection>
              <FooterHeading>Servicegebieden</FooterHeading>
              <FooterText tw={"text-center"}>
                Wij bieden slotenmakerdiensten aan door heel nederland o.a. in Amsterdam, Rotterdam, Utrecht, Den Bosch, Eindhoven, Den Haag, Lelystad, Maastricht, Groningen, Leeuwarden, Assen, Zwolle, Arnhem en Middelburg.
              </FooterText>
            </FooterSection>
            <FooterSection>
              <FooterHeading>Openingstijden</FooterHeading>
              <FooterText tw={"text-center"}>
                Maandag - Zondag: 24/7 geopend<br />
              </FooterText>
            </FooterSection>
            <img className={"w-80"} src={"/logo-vca.png"}/>
          </Row>
          
          <Link className={"flex flex-col border-none text-center items-center"} href="/offerte-aanvragen">
            <PrimaryButton tw={"text-center"} key={2}>
              Offerte aanvragen
            </PrimaryButton>
          </Link>
          <CopyrightText tw={"md:mb-0 mb-10"}>
            &copy; Copyright 2022, OmnifexIT. Alle rechten voorbehouden.
          </CopyrightText>
        </Content>
      </Container>
  );
};
